import { TrafficSourcesList } from '../components/TrafficSourcesList';

export const TrafficSourcesPage = () => {
  return <TrafficSourcesList />;
};
